import { useTranslation } from 'react-i18next';

import * as St from './WhatToExpectSection.styles';
import FabricationIcon from '/public/assets/icons/Fabrication Icon.svg';
import InstallIcon from '/public/assets/icons/Install Icon.svg';
import PurchasingIcon from '/public/assets/icons/Purchasing Icon.svg';
import SchedulingIcon from '/public/assets/icons/Scheduling Icon.svg';
import VerificationIcon from '/public/assets/icons/Verification Icon.svg';

import PunchHolesGroup from '~/UI/components/atoms/PunchHolesGroup';
import { useRetailerDocument } from '~/core/hooks/useRetailerDocuments';
import { RetailerDocumentType } from '~/core/models';
import PageTitle from '~atoms/PageTitle';
import PunchHoleItem from '~atoms/PunchHoleItem';

const WhatToExpectSection = (): JSX.Element => {
  const { t } = useTranslation();
  const templateChecklistURL = useRetailerDocument(
    RetailerDocumentType.TEMPLATE_CHECKLIST
  );
  const installationChecklistURL = useRetailerDocument(
    RetailerDocumentType.INSTALL_CHECKLIST
  );

  return (
    <St.Container>
      <PageTitle>{t('ORDER_SUMMARY.WHAT_TO_EXPECT.TITLE')}</PageTitle>
      <PunchHolesGroup>
        <PunchHoleItem
          icon={<PurchasingIcon />}
          title={t('ORDER_SUMMARY.WHAT_TO_EXPECT.PURCHASE_TITLE')}
          content={t('ORDER_SUMMARY.WHAT_TO_EXPECT.PURCHASE_CONTENT')}
        />
        <PunchHoleItem
          icon={<SchedulingIcon />}
          title={t('ORDER_SUMMARY.WHAT_TO_EXPECT.SCHEDULING_TITLE')}
          content={t('ORDER_SUMMARY.WHAT_TO_EXPECT.SCHEDULING_CONTENT')}
          link={
            templateChecklistURL
              ? {
                  href: templateChecklistURL,
                  text: t(
                    'ORDER_SUMMARY.WHAT_TO_EXPECT.SCHEDULING_CONTENT_CLICKABLE'
                  ),
                }
              : undefined
          }
        />
        <PunchHoleItem
          icon={<VerificationIcon />}
          title={t('ORDER_SUMMARY.WHAT_TO_EXPECT.VERIFICATION_TITLE')}
          content={t('ORDER_SUMMARY.WHAT_TO_EXPECT.VERIFICATION_CONTENT')}
        />
        <PunchHoleItem
          icon={<FabricationIcon />}
          title={t('ORDER_SUMMARY.WHAT_TO_EXPECT.FABRICATION_TITLE')}
          content={t('ORDER_SUMMARY.WHAT_TO_EXPECT.FABRICATION_CONTENT')}
        />
        <PunchHoleItem
          icon={<InstallIcon />}
          title={t('ORDER_SUMMARY.WHAT_TO_EXPECT.INSTALL_TITLE')}
          content={t('ORDER_SUMMARY.WHAT_TO_EXPECT.INSTALL_CONTENT')}
          link={
            installationChecklistURL
              ? {
                  href: installationChecklistURL,
                  text: t(
                    'ORDER_SUMMARY.WHAT_TO_EXPECT.INSTALL_CONTENT_CLICKABLE'
                  ),
                }
              : undefined
          }
        />
      </PunchHolesGroup>
    </St.Container>
  );
};

export default WhatToExpectSection;
